<template>
  <div class="w-full h-full flex-col mx-2 min-h-[350px]">
    <div class="bg-gradient-to-b from-[#B0D0FF]/70 h-36 w-[100%] absolute rounded-t-lg left-0 top-0 pointer-events-none" />
    <div class="flex items-center w-full">
      <Group class="w-12 h-12 -ml-1" color="#000" />
      <span class="mt-1 ml-2 text-3xl font-bold text-black">{{ $t("Create Group") }}</span>
      <div
        class="w-8 h-8 ml-auto mr-3 bg-white border rounded-full cursor-pointer has-tooltip dark:border-dark-divider-border dark:bg-dark-screen-background"
        @click="$emit('cancel')">
        <X color="#FF0000" class="w-6 h-6 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration" /><span
          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
          {{ $t("Close") }}</span>
      </div>
    </div>
    <div class="text-common-grey">
      {{ $t("Create Groups to use it for quick record filtering.") }}
    </div>

    <div class="mt-4 pt-2">
      <SelectInput
        v-model="object_type"
        :items="$store.state.object_types"
        :value="$store.state.object_types.filter((o) => o.type == object_type)[0].type"
        :disabled="objectType ? true : false"
        name="prospecting_filter"
        label-attr="label"
        value-attr="type"
        :allow-null="false"
        :is-box-background="true"
        :inline-label="true"
        :show-label="false"
        :classes="`w-full mb-2`"
        :label="$t('Filter by')"
        :placeholder="$t('Select object to filter with')" />
      <div class="flex items-center justify-center my-2">
        <TextInput
          v-model="group_name"
          class="w-full"
          :is-box-background="true"
          :show-label="false"
          :auto-focus="false"
          input-classes="appearance-none block px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light bg-white focus:border-blue-light sm:text-sm"
          name="name"
          type="text"
          :placeholder="$t('Group name')"
          label=""
          @input="group_name = $event.target.value" />
        <div class="flex flex-row items-center gap-2 ml-2">
          <label class="block text-base font-medium text-gray-700 dark:text-dark-body-text">{{ $t("Private") }} </label>
          <Switch
            v-model="is_public"
            :class="[
              !is_public ? 'bg-blue' : 'bg-gray-200 dark:bg-dark-screen-background',
              'relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
            ]">
            <span
              aria-hidden="true"
              :class="[
                !is_public && $store.state.portfolio.ui_options?.language == 'ar'
                  ? '-translate-x-5'
                  : !is_public
                    ? 'translate-x-5'
                    : 'translate-x-0',
                'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
              ]" />
          </Switch>
        </div>
      </div>

      <TextArea
        classes="w-full mt-2"
        input-classes="dark:bg-dark-box-background bg-light-box-background dark:text-dark-body-text px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-md"
        show-label
        :label="$t('Description')"
        name="description"
        @input="description = $event.target.value" />

      <div>
        <div class="text-xl font-medium relative top-4">
          {{ $t("Group Filter") }}:
        </div>
        <AdvancedMetricsFilterForm :initial-filter="filter" :object-type="objectType" @update="handleUpdateFilter" />
      </div>
    </div>
    <div class="flex flex-row-reverse items-center w-full gap-2 mt-12">
      <button class="primary-btn w-fit" @click="createGroup()">
        <span>{{ $t("Create") }}</span>
        <Check class="w-6 h-6 ml-2" aria-hidden="true" />
      </button>
      <button
        type="button"
        class="w-fit cancel-btn py-2.5 -ml-1"
        @click="
          () => {
            $emit('cancel')
          }
        ">
        <span>{{ $t("Cancel") }}</span>
      </button>
    </div>
  </div>
</template>
<script>
import dataService from "@/services/data.service"
import SelectInput from "@/components/shared/SelectInput.vue"
import TextInput from "@/components/shared/TextInput.vue"
import TextArea from "@/components/shared/TextArea.vue"
import { Switch } from "@headlessui/vue"
import { Group, Check, X } from "lucide-vue-next"
import AdvancedMetricsFilterForm from "@/components/forms/AdvancedMetricsFilterForm.vue"
import { transformMetricFilterToServerFilter } from "@/services/data.transformers"

export default {
  components: {
    SelectInput,
    AdvancedMetricsFilterForm,
    Group,
    Check,
    X,
    TextInput,
    TextArea,
    Switch
  },
  props: {
    objectType: {
      type: String,
      required: false
    }
  },
  emits: ["done", "cancel"],
  data() {
    return {
      object_type: "company",
      filter: "",
      is_filter_valid: false,
      filter_error: false,
      group_name: "",
      description: "",
      is_public: true,
      server_filter: null
    }
  },
  watch: {
    object_type() {
      this.filter = ""
      this.is_filter_valid = false
    },
    filter() {
      this.filter_error = false
    }
  },
  created() {
    if (this.objectType) {
      this.object_type = this.objectType
    }
  },
  methods: {
    handleUpdateFilter(filter) {
      const filter_cleaned = []
      filter.forEach((item) => {
        if (item.data_type == "String") {
          if (Array.isArray(item.value)) {
            item.value = String(item.value)
          }
          // let value = item.value.replace(/[']+/g, "")
          filter_cleaned.push({
            ...item,
            value: item.value == null ? "" : item.value.trim()
          })
        } else {
          if (
            item.value == null ||
            item.value == undefined ||
            item.value == "" ||
            item.value == "null" ||
            item.value == "undefined" ||
            item.value == "None"
          ) {
            item.value = null
          } else if (
            (item.data_type == "Date" || item.data_type == "DateTime") &&
            !(
              item.operator.value == "__DAYS_WITHIN_LAST_X_DAYS__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_AGO__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_AGO__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__" ||
              item.operator.value == "__DAYS_WITHIN_NEXT_X_DAYS__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_FROM_NOW__"
            )
          ) {
            item.value = this.$moment(item.value).format("YYYY-MM-DD")
          } else if (
            item.data_type == "DateTime" &&
            !(
              item.operator.value == "__DAYS_WITHIN_LAST_X_DAYS__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_AGO__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_AGO__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__" ||
              item.operator.value == "__DAYS_WITHIN_NEXT_X_DAYS__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_FROM_NOW__"
            )
          ) {
            item.value = this.$moment(item.value).format("YYYY-MM-DDTHH:mm:ss")
          }
          filter_cleaned.push({ ...item, value: item.value })
        }
      })
      let parsed_filter = transformMetricFilterToServerFilter([...filter_cleaned])

      this.server_filter = parsed_filter.filter
    },
    createGroup() {
      if (!this.filter && !this.server_filter) {
        this.filter_error = true
      } else {
        let data = {
          name: this.group_name,
          description: this.description,
          is_public: this.is_public,
          filter: this.server_filter ? this.server_filter : this.filter,
          object_type: this.$utils.getObjectTypeByType(this.object_type).id
        }
        dataService.createGroup(data).then(() => {
          this.$emit("done")
          setTimeout(() => {
            this.$store.dispatch("data/getGroups")
          }, 500)
        })
      }
    }
  }
}
</script>
